import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import _get from 'lodash/get';
import { colors } from '@lifesize/ux-assets';
import { authSelectors, environmentSelectors } from '@lifesize/nucleus';
import { ReactComponent as CrownIcon } from '@lifesize/ux-assets/vectors/svgIcons/crown.svg';
import { makeStyles, Theme } from '@material-ui/core';
import lsConfig from 'utils/global-config';
import { getShopUrl } from 'utils/UrlUtil';

const UpgradeButton = () => {
  const classes = useStyles({});

  const jwt = useSelector((state) => authSelectors.getPrimaryJwt(state));
  const upgradeURL = getShopUrl(jwt);
  const isDesktop = useSelector((state) => environmentSelectors.platform(state).isDesktop);
  const sendToShop = () => {
    lsConfig.skipTimeOnBeforeUnload(1000);
    if (isDesktop) {
      window.open(upgradeURL);
    } else {
      window.location.href = upgradeURL;
    }
  };
  const showUpgrade = useSelector((state) => _get(state, 'app.flags.displayUpgradeLink', false));

  if (!showUpgrade) return null;
  return (
    <button className={classes.button} data-testid="upgradeButton" onClick={sendToShop}>
      <CrownIcon />
      <FormattedMessage id="components.upgradeButton.label" description="Upgrade Label" defaultMessage="Upgrade Plan" />
    </button>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    alignItems: 'center',
    backgroundColor: colors.lifesizeBlue,
    border: 0,
    borderRadius: 15,
    color: colors.white,
    display: 'flex',
    fontSize: 14,
    height: 30,
    marginLeft: 30,
    padding: '0 14px 0 8px',

    '& svg': {
      height: 26,
      marginRight: 6,
      width: 'auto'
    },

    '& span': {
      marginTop: 1
    }
  }
}));

export default UpgradeButton;
